import {Component, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { ClaimsBaseComponent } from '../claim-base.component';
import { TransactionInfoService } from '../../services/transaction-info.service';
import { SideMenuService } from '../../services/side-menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import {TransactionInfo} from "../../model/transaction-info.model";
import {InsuredPerson} from "../../model/insured-person.model";
import {ClaimService} from "../../services/claim.service";
import { DateService } from 'src/app/ui/ui-datepicker/date.service';
import { takeUntil } from 'rxjs';
import { Notifications } from 'src/app/utilities/components/notification-messages/notifications.model';

@Component({
    selector: 'app-confirm-travel-period',
    templateUrl: './confirm-travel-period.component.html',
    styleUrls: ['./confirm-travel-period.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmTravelPeriodComponent extends ClaimsBaseComponent  implements OnInit {
    confirmTravelModel: FormGroup;
    transactionInfo: TransactionInfo;
    public insuredPersonList: InsuredPerson[] = [];
    notifications: Notifications = new Notifications();

    constructor(private fb: FormBuilder,
                private transactionInfoService: TransactionInfoService,
                private sideMenuService: SideMenuService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private claimService: ClaimService,
                private dateService: DateService,
                private injector : Injector) {

        super(injector);
        this.notifications.showPreamble = false;
    }

    ngOnInit() {
        this.transactionInfo = this.injector.get(TransactionInfoService).getTransactionInfo();
        this.insuredPersonList  = this.transactionInfo.getInsuredPersonsList();
        this.pushGAViewConfirmTravel();

        this.confirmTravelModel = this.fb.group({
            originalDepartureDate: [this.claim.getClaimTravel().getOriginalDepartureDate()],
            originalReturnDate: [this.claim.getClaimTravel().getOriginalReturnDate()],
            otherDateOfIncident: [this.claim.getDateOfLoss()]
        });
    }

    ngAfterViewInit() {
         this.confirmTravelModel.valueChanges.subscribe(data => {
            this.claim.getClaimTravel().setOriginalDepartureDate(super.getValueInComponent('originalDepartureDate'));
            this.claim.getClaimTravel().setOriginalReturnDate(super.getValueInComponent('originalReturnDate'));
            if (this.transactionInfo.shouldShowDateOfLoss()) {
                this.claim.setDateOfLoss(super.getValueInComponent('otherDateOfIncident'));
            }
        });
    }

    goToNext() {
        if (this.validateForm()) {
            this.notifications.clearMessages();
            this.sideMenuService.emitConfirmTravelPeriod('');
            this.sideMenuService.emitComplete('finishConfirmTravelPeriod');
            this.sideMenuService.emitProgress(1);

            if (this.transactionInfo.shouldShowDateOfLoss()) {
                this.transactionInfoService.checkForNewArrangement(this.claim,
                    this.transactionInfo,
                    this.dateService.dateToString(this.claim.getDateOfLoss(), "dd/MM/yyyy"))
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe({
                        next: () => this.navigateToNextStep(),
                        error: (err: any) => {
                            const errorMessage1 = "error_messages.notificationsErrMsg.serverErrVerifyPolicy";
                            this.notifications.addErrorMessage(errorMessage1);
                            throw new Error("PLCYERR - Server Error verifying policy in New Arrangement : " + err);
                        }
                    });
            } else {
                this.navigateToNextStep();
            }
        }
    }

    private navigateToNextStep() {
        if (this.transactionInfo.hasSingleInsured()) {
            const insuredPerson = this.insuredPersonList[0];
            this.claimService.setInsuredPerson(this.transactionInfo, insuredPerson);
            if (!this.transactionInfo.isDomesticHelperProduct()) {
                this.sideMenuService.emitSelectInsured(insuredPerson.getInsuredName());
            }
            const url = '/claimform/claimDetail';
            this.router.navigate([url], {
                relativeTo: this.activatedRoute
            });
        } else {
            this.router.navigate(["/claimform/selectInsured"], {
                relativeTo: this.activatedRoute
            });
        }
    }

    validateForm(): boolean {
        return super.validateForm(this.confirmTravelModel);
    }

    //Google Analytics
    pushGAViewConfirmTravel() {
        let claimInfo = this.claim;
        let channel: string = "";
        if (!UtilitiesService.isNullOrUndefined(claimInfo) && !UtilitiesService.isNullOrUndefined(claimInfo.getCountry())) {
            if (claimInfo.getCountry() == "HGI") {
                 channel = "QGI";
            }  else {
                if (claimInfo.getIsManulife()) {
                    channel = "Manulife";
                } else {
                    channel = "HKSI";
                }
            }
        }

        (<any>window).dataLayer.push({
            'pageStep': 'Confirm Travel Period',
            'Channel': channel,     // QGI, HKSI or Manulife
            'vPath': '/confirm-travel-period',
            'event': 'vpageview',
        });
    }
}
